import React from 'react';
import RaisePayRateEdit from './RaisePayRateEdit';

function RaisePayRateCard({ item }) {
  return (
    <div className="RaisePayRateCard card">
      <div className="card-body">
        <h5 className="card-title">
          <i className={item.class}></i>{item.name}
        </h5>
        <h6 className="card-subtitle">
          Min: ${item.minimum_rate} - Max: ${item.maximum_rate}
        </h6>

        <RaisePayRateEdit item={item} />
      </div>
    </div>
  )
}

export default RaisePayRateCard
